import React, { FC } from 'react';
import styled from 'styled-components';

import colors from '@pickles/shared/utils/colors';

interface IFieldHint {
  error?: boolean;
  message?: string;
}

const FieldHint: FC<IFieldHint> = ({ error, message }) => {
  return <Component error={error}>{message}</Component>;
};

export default FieldHint;

const Component = styled.div<IFieldHint>`
  font-family: BasierCircle;
  font-weight: 400;
  font-size: 13px;
  color: ${({ error }) => error ? colors.cerise_red : colors.san_juan_grey_08};
  margin-top: 6px;
  text-align: left;
`;
